import { ActionTypes } from './actionTypes';
import type { GeocodeAction } from './actions';

import { type BatchAddress, type WebData, webDataError, webDataFetching, webDataNotAsked, webDataSuccess } from '@cobliteam/api-lib';

interface GeocodeState {
  latLngBatchWebData: WebData<BatchAddress[]>;
}

export const geocodeInitialState: GeocodeState = {
  latLngBatchWebData: webDataNotAsked(),
};

export const geocodeReducer = (state: GeocodeState = geocodeInitialState, action: GeocodeAction): GeocodeState => {
  if (!(action.type in ActionTypes)) {
    return state;
  }

  switch (action.type) {
    case ActionTypes.GEOCODE_LAT_LNG_BATCH_REQUEST:
      return {
        ...state,
        latLngBatchWebData: webDataFetching(),
      };

    case ActionTypes.GEOCODE_LAT_LNG_BATCH_SUCCEEDED:
      return {
        ...state,
        latLngBatchWebData: webDataSuccess(action.payload),
      };

    case ActionTypes.GEOCODE_LAT_LNG_BATCH_FAILED:
      return {
        ...state,
        latLngBatchWebData: webDataError(),
      };

    default:
      return state;
  }
};
